import { FaInstagram, FaTwitter, FaTiktok, FaLinkedin } from "react-icons/fa";
import Muzify from "../assets/images/Muzify.png"
import BookToPlaylist from "../assets/images/BookToPlaylist.png"
import Fanpit from "../assets/images/Fanpit.png"
import ImFeeling from "../assets/images/ImFeeling.png"
import PetPlaylistImage from "../assets/images/PetPlaylistImage.png"

export const ASSET_MONEY_TITLE = 'Asset Money';
export const CLEVERTAP_ACCOUNT_ID = 'TEST-TEST-TEST';

export const SOCIALS = [
    {
      name: "instagram",
      link: "https://www.instagram.com/muzifyhq/",
      icon: <FaInstagram fontSize={'1.5em'} color="#190F96" />
    },
    {
      name: "twitter",
      link: "https://x.com/MuzifyHQ",
      icon: <FaTwitter fontSize={'1.5em'} color="#190F96"/>
    },
    {
      name: "tiktok",
      link: "https://www.tiktok.com/@muzifyhq",
      icon: <FaTiktok fontSize={'1.5em'} color="#190F96"/>
    },
    {
        name: "linkedin",
        link: "https://in.linkedin.com/company/muzifyhq",
        icon: <FaLinkedin fontSize={'1.5em'} color="#190F96"/>
    }
];

export const PAGES = [
    {
        name: "privacypolicy",
        text: "Privacy Policy",
        link: "https://muzify.com/privacy-policy"
    },
    {
        name: "tnc",
        text: "Terms & Conditions",
        link: "https://muzify.com/terms-and-conditions"
    },
    {
        name: "faq",
        text: "FAQs",
        link: "https://teamasset.notion.site/Muzify-Frequently-Asked-Qestions-10c1997bfe678071b55ec93c915351a2?pvs=4"
    },
    {
        name: "partner",
        text: "Partner With Us",
        link: "https://tally.so/r/mKL17D"
    },
    {
        name: "contact",
        text: "Contact Us",
        link: "https://tally.so/r/nWevAN"
    },
];

export const ALL_APPS = [
    {
        appName: "Muzify App",
        description: "Challenge your music knowledge. Dive into quizzes and uncover new artists and genres.",
        image: Muzify,
        link: "https://muzify.onelink.me/PNu3/39ussg3x"
    },
    {
        appName: 'ImFeeling',
        description: "Challenge your music knowledge. Dive into quizzes and uncover new artists and genres.",
        image: ImFeeling,
        link: "https://muzify.com/imfeeling/"
    },
    {
        appName: 'Book To Playlist',
        description: "Challenge your music knowledge. Dive into quizzes and uncover new artists and genres.",
        image: BookToPlaylist,
        link: "https://muzify.com/booktoplaylist"
    },
    {
        appName: 'PetPlaylist',
        description: "Challenge your music knowledge. Dive into quizzes and uncover new artists and genres.",
        image: PetPlaylistImage,
        link: "https://petplaylist.xyz/"
    },
    {
        appName: 'Fanpit',
        description: "Challenge your music knowledge. Dive into quizzes and uncover new artists and genres.",
        image: Fanpit,
        link: "https://fanpit.muzify.com/"
    },
]